import { useRef, useEffect } from 'react';
import * as React from 'react';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import StatusLabel from '@sdk/components/ui/StatusLabel';
import Row from '@sdk/components/ui/spacing/Row';
import type { SpacingType } from '@sdk/components/ui/spacing/SpacingStyle';

import usePremiumGuard from '@web/premiumGuard/usePremiumGuard';
import { CustomStatusLabel } from '@web/premiumGuard/premiumGuardLabel.styles';

type Props = {
  label: string;
  tooltipId?: string;
  tooltipText?: string;
  useLabelForSelectBox?: boolean;
} & SpacingType;

const PremiumGuardLabel: React.FC<React.PropsWithChildren<Props>> = ({
  tooltipId,
  label,
  tooltipText,
  useLabelForSelectBox = false,
  ...props
}) => {
  const tooltipRef = useRef();
  const { addTooltipRef } = usePremiumGuard();

  useEffect(() => {
    if (tooltipId) {
      addTooltipRef(tooltipId, tooltipRef);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Label = useLabelForSelectBox ? CustomStatusLabel : StatusLabel;

  return (
    <Row
      ref={tooltipRef}
      className="active-pointer"
      data-tip={tooltipText}
      justifyContent="center"
      alignItems="center"
      {...props}>
      <Label label={label} />
      {!!tooltipText && <Tooltip attachToBody />}
    </Row>
  );
};

export default PremiumGuardLabel;
